import { sortBy } from "lodash";
const getInitialIBData = (IBData, selectedShipmentIds) => {
  const formattedData = IBData.data.map((data) => {
    const selectedPros = getSelectedProIdsInBatch(
      data.shipmentsForDestTerminal,
      selectedShipmentIds
    );
    const inPlanBills = getExistingShipmentsInPlan(
      data.shipmentsForDestTerminal
    ).map((pro) => pro.proId);
    const totalBillsSelected = [...selectedPros, ...inPlanBills];
    return {
      ...data,
      shipmentsForDestTerminal : sortBy(data.shipmentsForDestTerminal,[
        (item) => !item.isDefaultSelection,
        (item) => !item.isInPlan,
      ]),
      id: getBatchId(data),
      selectedPros,
      isSelected: checkAllBillsSelectedInBatch(
        totalBillsSelected.length,
        data.shipmentsForDestTerminal.length
      ),
      isIntermediate: checkPartialBillsSelectedInBatch(
        totalBillsSelected.length,
        data.shipmentsForDestTerminal.length
      ),
    };
  });
  return sortBy(formattedData, [
    (item) => !item.isSelected,
    (item) => !item.isIntermediate,
  ]);

};

const getBatchId = (data) => {
  return [
    data.trailerNumber,
    data.trailerScac,
    data.currentTerminal,
    data.destTerminal,
  ].join("");
};

const getSelectedProIdsInBatch = (batchPros, selectedShipmentIds) => {
  return batchPros
    .filter(
      (pro) =>
        selectedShipmentIds?.includes(pro.proId) ||
        (pro.isDefaultSelection && !pro.isInPlan)
    )
    .map((pro) => pro.proId);
};

const getExistingShipmentsInPlan = (shipments) => {
  return shipments.filter((pro) => pro.isInPlan);
};

const checkInPlanShipmentsExistInBatch = (batchShipments) => {
  return batchShipments.some((pro) => pro.isInPlan);
};

const checkAllBillsSelectedInBatch = (
  totalBillsSelected,
  totalBillsInBatch
) => {
  return totalBillsSelected === totalBillsInBatch;
};

const checkPartialBillsSelectedInBatch = (
  totalBillsSelected,
  totalBillsInBatch
) => {
  return totalBillsSelected > 0 && totalBillsSelected < totalBillsInBatch;
};

export {
  getInitialIBData,
  getExistingShipmentsInPlan,
  checkInPlanShipmentsExistInBatch,
  checkAllBillsSelectedInBatch,
  checkPartialBillsSelectedInBatch,
};
